﻿import { init, captureException, type BrowserOptions } from '@sentry/browser';

const meta = document.querySelector<HTMLMetaElement>('meta[name="sentry"]');
if (meta) {
    init(JSON.parse(meta.content) as BrowserOptions);
}

// window.Sentry.captureException is used by the try/catch wrapper in gulpfile.js
export { captureException };
